<script setup>
  import { ref, onMounted } from 'vue'
  import { fetchWrapper } from '@/helpers/fetch-wrapper'
  import { useProfileStore } from '@/stores/profile.store'
  import CurriculumTopicSlide from '@/components/CurriculumTopicSlide.vue'
  import LanguageStreakHeader from '@/components/LanguageStreakHeader.vue'
  const profileStore = useProfileStore()
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
  const router = useRouter()
  const categories = ref([])
  const suggestedUnits = ref([])
  const language = ref('')
  const invalidLanguage = ref(false)
  const isLoading = ref(true)
  async function load_categories() {
    try {
      const params = {
        native_language: profileStore.profile.native_language,
        learning_language: profileStore.profile.learning_language,
      }
      const query = new URLSearchParams(params)
      const response = await fetchWrapper.get(`/curriculum/categories/?${query}`)
      categories.value = response
      invalidLanguage.value = false
    } catch (error) {
      language.value = 'Error'
      invalidLanguage.value = true
      categories.value = []
    }
  }

  async function load_suggested_units() {
    try {
      const params = {
        language: profileStore.profile.learning_language,
      }
      const query = new URLSearchParams(params)
      const response = await fetchWrapper.get(`/curriculum/unit-recommendations/?${query}`)
      suggestedUnits.value = response
    } catch (error) {
      console.error('Error loading suggested units:', error)
      suggestedUnits.value = []
    }
  }

  onMounted(async () => {
    await profileStore.fetchProfile()
    await load_categories()
    await load_suggested_units()
    isLoading.value = false
  })

  async function changeLanguage() {
    await load_categories()
    await load_suggested_units()
  }
</script>
<template>
  <nice-header />
  <loading-overlay v-model:active="isLoading" :can-cancel="true" is_full_page="false" loader="dots" :opacity="0.8" />
  <div v-if="!isLoading">
    <section class="my-0">
      <div class="container tutorial">
        <language-streak-header @changeLanguage="changeLanguage" />
        <div class="bg-white border-0 rounded border-light p-1 p-sm-2 p-md-5 w-100 fmxw-500">
          
            <h2 class="card-title text-start fs-3 fw-semibold mb-0">{{ t('curriculum.suggestions') }}</h2>
            <div class="row mt-4 mb-5">
              <div class="mb-4 col-lg-6"  v-for="unit in suggestedUnits" :key="unit.id">
                <div class="card shadow">
                  <div class="card-body p-2 ps-1">
                    <CurriculumTopicSlide :unit="unit" :to="{ name: 'CurriculumUnitView', params: { unitID: unit.id } }" />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <h2 class="card-title text-start fs-3 fw-semibold mb-0 mt-5">{{ t('curriculum.categories') }}</h2>
            <div class="row mt-4">
              <div class="mb-4 col-lg-6" v-for="category in categories" :key="category.id">
                <div class="card shadow">
                  <div class="card-body p-2 ps-1">
                    <CurriculumTopicSlide :category="category" :to="{ name: 'CurriculumCategoryView', params: { categoryID: category.id } }" />
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  </div>
  <nice-footer />
</template>
<style scoped>
a {
  text-decoration: none;
  color: var(--primary-color);
}
/* .card {
  width: 115px;
  height: 100px;
} */
.card, .card-body{
  border-radius: 15px;
}
.card:hover{
  cursor:pointer;
  background-image: linear-gradient(0deg, #f0f8ff, transparent) !important;
  transition: .5s ease-in-out;
}
</style>

